import Com from "components/styledComp/CommStyledComp";
import React from "react";

//Rod Cutting 알고리즘 섹션
const RodCutting = () => {
    return(
        <Com.DivDetailSection border="false">
            <Com.DivDetailHeading>
                <Com.DetailHeading>Rod Cutting</Com.DetailHeading>
            </Com.DivDetailHeading>
            <div className="strategy-list">
                <div className="strategy">
                    <div className="schedule-dogyo">
                        <Com.StrongStrategy underline={true}>개요</Com.StrongStrategy>
                        <div className="strategy-desc">
                            <p>긴 막대를 일정한 길이로 자를경우 자투리 Loss를 최소화 하는 알고리즘<br/></p>
                            <p>
                            예를 들면 1M의 금속 막대(스틸, 알루미늄 등)를 고객이 20Cm, 50Cm, 60Cm 등과<br/>
                            같이 다양한 길이를 요구하여 잘라서 판매할 경우 자투리 Loss가 최소화 되도록<br/>
                            잘라야 할 경우 어떻게 자를지를 제시해 주는 알고리즘임<br/>
                            </p>
                        </div> 
                    </div>
                </div>
                <div className="strategy">
                    <div className="schedule-dogyo">
                        <Com.StrongStrategy underline={true}>Rod Cutting 알고리즘</Com.StrongStrategy>
                        <div className="strategy-desc">
                            <p>본 알고리즘은 완전 탐색(Brute Force) 방식으로 구현되었으며 모든 조합을 탐색하여<br/>
                            최적의 결과를 출력 한다</p>
                            <p>
                                <span>초기값 설정: </span>금속 막대 길이 : 1000mm<br/>
                            </p>
                            <p>
                                <span>고객 요구사항: </span>150mm 100개, 120mm 80개, 100mm 50개, 80mm 60개 등<br/>
                            </p>
                            <p>
                                <span>최적화 탐색: </span>자투리가 "0"인 조합의 값을 다차원 방정식으로 찾는다<br/>
                            </p>
                            <p>
                                <span>반복 최적화: </span>특정 조합의 합이 1000mm와 일치하는 경우가 없을 경우<br/>
                                10mm씩 줄여가면서 최적의 조합을 반복적으로 수행함<br/>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </Com.DivDetailSection>
    );
}

export default RodCutting; 